import { createGlobalStyle } from "styled-components";

const PdsFooterStyles = createGlobalStyle`

.pds-footer {
	background-color: #333;
	padding-top: 48px;
	padding-bottom: 52px
}

@media only screen and (max-width:720px) and (min-width:0) {
	.pds-footer {
		padding-bottom: 36px
	}
}

.pds-footer ul.pds-footer-nav-inline {
	-webkit-padding-start: 0;
	padding-inline-start: 0
}

.pds-footer ul.pds-footer-nav-inline li {
	display: inline
}

.pds-footer ul.pds-footer-nav-inline li:not(:last-child):after {
	content: '|';
	padding: 0 24px
}

@media only screen and (max-width:720px) and (min-width:0) {
	.pds-footer ul.pds-footer-nav-inline:not(:first-child) li:not(:last-child):after {
		content: '';
		padding: 0
	}
	.pds-footer ul.pds-footer-nav-inline:not(:first-child) li {
		display: block
	}
}

.pds-footer ul.pds-footer-nav-inline a {
	color: #fff!important;
	white-space: nowrap
}
.pds-footer ul li span:hover {
	text-decoration: none;
}
.pds-footer ul.pds-footer-nav-inline a span.pds-footer-spacer {
	margin-left: 8px
}

.pds-footer ul.pds-footer-nav-inline a.pds-footer-link {
	border-bottom: 1px dashed #fff
}

.pds-footer ul.pds-footer-nav-inline a.pds-footer-link:active,
.pds-footer ul.pds-footer-nav-inline a.pds-footer-link:hover {
	border-bottom: 1px solid #fff;
}

.pds-footer .pds-footer-row {
	text-align: center;
	color: #fff!important
}

.pds-footer .pds-footer-row a {
	color: #fff!important
}

.pds-footer .pds-footer-legal {
	margin-top: 32px;
	font-size: 14px;
	color: #fff
}

.pds-footer .pds-footer-legal p span:hover, 
.pds-footer .pds-footer-legal a:hover {
	text-decoration: none;
}

.pds-footer a {
	border-bottom: 1px dashed #fff;
	white-space: nowrap
}

.pds-footer a:active,
.pds-footer a:hover {
	border-bottom: 1px solid #fff;
	text-decoration: none;
}
.pds-footer .pds-login-help-link,
.pds-footer .pds-login-help-link a {
	font-size: 1.25rem
}

`;

export default PdsFooterStyles;
